import { render, staticRenderFns } from "./ExportAfpnetModal.vue?vue&type=template&id=72c865aa"
import script from "./ExportAfpnetModal.vue?vue&type=script&lang=js"
export * from "./ExportAfpnetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports